import { useCustomerTokens } from '@hooks/customer/useCustomerTokens';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { gql } from 'graphql-request';
import type { SWRConfiguration } from 'swr';

import { InvalidTokenError } from '@repo/ui/src/utils/errors';
import { GraphQLRequestWithTokenProps, requestWithTokenRequired } from '@utils/graphql-request';
import useSWRImmutable from 'swr/immutable';

export const SelfFragment = gql`
  fragment Self on User {
    firstName
    lastName
    phone
    email
    avatar
    vip
  }
`;

const GET_SELF = gql`
  ${SelfFragment}
  query GetSelf {
    getSelf {
      ...Self
    }
  }
`;

export interface Self {
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
  avatar?: string;
  emailSubscribed?: boolean;
  smsSubscribed?: boolean;
  vip?: boolean;
}

const fetcher = async (props: GraphQLRequestWithTokenProps) => {
  try {
    const data = await requestWithTokenRequired(props);
    if (!data) {
      return;
    }
    return data.getSelf as Self;
  } catch {
    throw new InvalidTokenError();
  }
};

export const useCustomer = (config: SWRConfiguration = {}) => {
  const { locale } = useCurrentUrl();
  const idToken = useCustomerIdToken();

  return useSWRImmutable<Self | undefined>({ document: GET_SELF, locale, idToken }, fetcher, {
    shouldRetryOnError: false,
    ...config,
  });
};

export const useCustomerIdToken = () => useCustomerTokens().data?.idToken ?? null;
